/* eslint-disable import-x/no-commonjs */
/*
 * This is an auto-generated file, any manual edits will be overridden.
 *
 * To regenerate, see instructions here:
 *   https://kolibri-dev.readthedocs.io/en/develop/i18n.html
 *
 * This file was generated by kolibri-i18n code-gen
 *
 * Polyfill files are copied to ./polyfills/ directory to avoid external dependencies.
 */
module.exports = function (locale) {
  switch (locale) {
    case 'ar':
      return import('vue-intl/locale-data/ar.js');
    case 'bg':
      return import('vue-intl/locale-data/bg.js');
    case 'bn':
      return import('vue-intl/locale-data/bn.js');
    case 'de':
      return import('vue-intl/locale-data/de.js');
    case 'el':
      return import('vue-intl/locale-data/el.js');
    case 'en':
      return import('vue-intl/locale-data/en.js');
    case 'es':
      return import('vue-intl/locale-data/es.js');
    case 'fa':
      return import('vue-intl/locale-data/fa.js');
    case 'fr':
      return import('vue-intl/locale-data/fr.js');
    case 'ff':
      return import('vue-intl/locale-data/ff.js');
    case 'gu':
      return import('vue-intl/locale-data/gu.js');
    case 'ha':
      return import('vue-intl/locale-data/ha.js');
    case 'hi':
      return import('vue-intl/locale-data/hi.js');
    case 'ht':
      return import('./polyfills/vue-intl/ht.js');
    case 'id':
      return import('vue-intl/locale-data/id.js');
    case 'it':
      return import('vue-intl/locale-data/it.js');
    case 'ka':
      return import('vue-intl/locale-data/ka.js');
    case 'km':
      return import('vue-intl/locale-data/km.js');
    case 'ko':
      return import('vue-intl/locale-data/ko.js');
    case 'mr':
      return import('vue-intl/locale-data/mr.js');
    case 'my':
      return import('vue-intl/locale-data/my.js');
    case 'ny':
      return import('vue-intl/locale-data/ny.js');
    case 'pa':
      return import('vue-intl/locale-data/pa.js');
    case 'pt':
      return import('vue-intl/locale-data/pt.js');
    case 'sw':
      return import('vue-intl/locale-data/sw.js');
    case 'te':
      return import('vue-intl/locale-data/te.js');
    case 'uk':
      return import('vue-intl/locale-data/uk.js');
    case 'ur':
      return import('vue-intl/locale-data/ur.js');
    case 'vi':
      return import('vue-intl/locale-data/vi.js');
    case 'yo':
      return import('vue-intl/locale-data/yo.js');
    case 'zh':
      return import('vue-intl/locale-data/zh.js');
    default:
      return import('vue-intl/locale-data/en.js');
  }
};
